import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import { withTranslation, Trans } from 'react-i18next';
import { cameraView06DeckFlexiteekImageOptions } from './views/CameraView06DeckFlexiteek'

class X49BathingPlatform extends Component {
    constructor(props) {
        super(props);
        this.handleTeakOnBathingPlatformChange = this.handleTeakOnBathingPlatformChange.bind(this);
    }

    handleTeakOnBathingPlatformChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnBathingPlatform = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = cameraView06DeckFlexiteekImageOptions;

        let image = <ConfiguratorImage boat="X4_9" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='X49 Bathing platform Text' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49BathingPlatform);


// WEBPACK FOOTER //
// ./src/X49/X49BathingPlatform.js